export default __webpack_public_path__ + "static/IMG_0417-8090ae7ffe608e5f5b8270037f625b2a.jpeg";